// extracted by mini-css-extract-plugin
export default {"classification":"BuYpVM9dai0F_t9O59uf"};